import { render, staticRenderFns } from "./BXBJS.vue?vue&type=template&id=3572476a&scoped=true"
import script from "./BXBJS.vue?vue&type=script&lang=js"
export * from "./BXBJS.vue?vue&type=script&lang=js"
import style0 from "./BXBJS.vue?vue&type=style&index=0&id=3572476a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572476a",
  null
  
)

export default component.exports